import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

const SetCardBreadCrumbs = props => {
  const { categoryDescr, modelDescr } = props;
  return (
    <div style={{padding: '10px', fontSize: '10px'}}>
      <span style={{color: '#555'}}>Каталог</span>
      {' - '}
      <span style={{color: '#555'}}>{categoryDescr}</span>
      {' - '}
      <span style={{color: '#555', fontWeight: 'bold'}}>{`Наборы модели ${modelDescr}`}</span>
    </div>
  );
}

SetCardBreadCrumbs.propTypes = {
  setsCurrent: PropTypes.string
}

export default connect(
  state => ({ categoryDescr: state.category[state.ui.category].descr, modelDescr: state.models[state.ui.model].descr })
)(SetCardBreadCrumbs);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/list/breadcrumbs.js